<template>
  <div id="student-parents">
    <!-- Pull up their data, with an add button -->
    <!-- table of students -->
    <b-container id="student-parents-table">
      <edit-parent
        v-if="showParentForm"
        :parent="parent"
        :editOrCreate="editOrCreate"
        :buttonTitle="buttonTitle"
        @click="onCreateParent"
      ></edit-parent>
      <b-button
        variant="primary"
        @click="showParentForm = !showParentForm"
        v-if="!showParentForm && isAdmin"
        >Create a New Parent</b-button
      >
      <b-row class="mt-4" v-if="!showParentForm">
        <b-col class="md-5">
          <div class="table-wrap">
            <br />
            <b-col>
              <h4 class="subtitle">
                Student's Parents/Guardians ({{ studentParents.length || 0 }})
              </h4>
              <b-form-group>
                <b-input-group>
                  <b-form-input v-model="filter" placeholder="Type to Search" />
                  <b-input-group-append>
                    <b-btn :disabled="!filter" @click="filter = ''"
                      >Clear</b-btn
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-table
              v-cloak
              responsive
              :fields="studentParentsFields"
              :items="studentParents"
              :striped="true"
              :bordered="true"
              :hover="true"
              stacked="md"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              @filtered="onFiltered"
            >
              <template slot="cell(sex)" slot-scope="row">{{
                row.item.sex === "male" ? "M" : "F"
              }}</template>
              <template slot="cell(active)" slot-scope="row">
                <b-form-radio-group
                  :id="row.item.uuid"
                  :value="row.item.active"
                  v-model="row.item.active"
                  @change="updateStudentParent(row)"
                >
                  <b-form-radio :value="true">True</b-form-radio>
                  <b-form-radio :value="false">False</b-form-radio>
                </b-form-radio-group>
              </template>
              <template slot="cell(edit)" slot-scope="row">
                <b-link class="edit" @click.stop="editStudentParent(row.item)"
                  >EDIT</b-link
                >
              </template>
              <template slot="cell(delete)" slot-scope="row">
                <b-link
                  class="delete"
                  @click.stop="deleteStudentParent(row.item.sp_id)"
                  >Delete Link</b-link
                >
              </template>
            </b-table>
            <b-row>
              <b-col class="my-1 md-5">
                <b-pagination
                  :total-rows="studentParents.length || 0"
                  :per-page="perPage"
                  v-model="currentPage"
                  class="my-0"
                />
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col v-if="isAdmin" class="md-5">
          <div class="table-wrap">
            <br />
            <h4 class="subtitle">School's Parents/Guardians</h4>
            <br />
            <div v-if="schoolParents.length">
              <b-col>
                <b-form-group>
                  <b-input-group>
                    <b-form-input
                      v-model="filterSearchResults"
                      placeholder="Type to Search"
                    />
                    <b-input-group-append>
                      <b-btn
                        :disabled="!filterSearchResults"
                        @click="filterSearchResults = ''"
                        >Clear</b-btn
                      >
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <div id="alerts" ref="student-parents-alert">
                  <b-alert
                    :show="dismissCountDown"
                    dismissible
                    variant="success"
                    @dismissed="dismissCountDown = 0"
                    @dismiss-count-down="countDownChanged"
                    >You have successfully added a parent!</b-alert
                  >
                  <b-alert
                    :show="dismissCountDownError"
                    dismissible
                    variant="danger"
                    @dismissed="dismissCountDownError = 0"
                    @dismiss-count-down="countDownChangedError"
                  >
                    This parent is already connected with this student.
                  </b-alert>
                </div>
              </b-col>
              <b-table
                v-cloak
                responsive
                :fields="schoolParentsFields"
                :items="schoolParents"
                :striped="true"
                :bordered="true"
                :hover="true"
                stacked="md"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filterSearchResults"
                @filtered="onFilteredResults"
              >
                <template slot="cell(sex)" slot-scope="row">{{
                  row.item.sex === "male" ? "M" : "F"
                }}</template>
                <template slot="cell(id)" slot-scope="row">
                  <b-link class="add" @click.stop="addParentToStudent(row)"
                    >ADD</b-link
                  >
                </template>
              </b-table>
              <b-row>
                <b-col md="6" class="my-1">
                  <b-pagination
                    :total-rows="schoolParents.length || 0"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0"
                  />
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ParentService from "../services/ParentService";
import NameSearch from "./NameSearch";
import EditParent from "./EditParent";
import { flash } from "../mixins/flashes";
import { scrollTo } from "../mixins/scrollTo";
import { onFiltered, onFilteredResults } from "../mixins/tableElements";

export default {
  name: "StudentParents",
  mixins: [flash, scrollTo, onFiltered, onFilteredResults],
  components: {
    NameSearch,
    EditParent,
  },
  data() {
    return {
      studentId: this.$route.params.id ? this.$route.params.id : null,
      isDisabled: true,
      showParentForm: false,
      studentParentsFields: [
        { key: "parent_name", label: "Name", sortable: true },
        { key: "sex", label: "sex", sortable: true },
        { key: "relation", label: "Relation", sortable: true },
        { key: "edit", label: "EDIT" },
        { key: "delete", label: "DEL" },
      ],
      schoolParentsFields: [
        { key: "parent_name", label: "name", sortable: true },
        { key: "sex", label: "sex", sortable: true },
        { key: "id", label: "ADD" },
      ],
      currentPage: 1,
      perPage: 20,
      pageOptions: [10, 20, 50],
      filter: null,
      filterSearchResults: null,
      parent: {
        id: null,
        sp_id: null,
        first_name: "",
        middle_name: "",
        last_name: "",
        sex: "",
        relation: "",
        mobile_1: "",
        mobile_2: "",
        email: "",
      },
      buttonTitle: "Create a Parent",
      editOrCreate: "Create",
    };
  },
  methods: {
    ...mapActions({
      GET_STUDENT_PARENTS: "parents/GET_PARENTS_BY_STUDENT",
      GET_SCHOOL_PARENTS: "parents/GET_SCHOOL_PARENTS",
      RESET_PARENTS_STATE: "parents/RESET_PARENTS_STATE",
      SEARCH_PARENTS: "searches/SEARCH_PARENTS",
      RESET_SEARCH: "searches/RESET_SEARCH_STATE",
    }),
    clearForm() {
      this.parent.id = null;
      this.parent.sp_id = null;
      this.parent.first_name = "";
      this.parent.middle_name = "";
      this.parent.last_name = "";
      this.parent.sex = "";
      this.parent.relation = "";
      this.parent.mobile_1 = "";
      this.parent.mobile_2 = "";
      this.parent.email = "";
    },
    async searchParents() {
      await this.SEARCH_PARENTS();
    },
    async editStudentParent(item) {
      const name = item.parent_name.split(" ");
      console.log(item);

      if (name.length > 2) {
        this.parent.first_name = name[0];
        this.parent.middle_name = name[1];
        this.parent.last_name = name[2];
      } else {
        this.parent.first_name = name[0];
        this.parent.last_name = name[1];
      }
      this.parent.id = item.id;
      this.parent.relation = item.relation;
      this.parent.sex = item.sex;
      this.parent.mobile_1 = item.mobile_1;
      this.parent.mobile_2 = item.mobile_2;
      this.parent.email = item.email;
      this.parent.sp_id = item.sp_id;

      this.buttonTitle = "Edit a Parent";
      this.editOrCreate = "Edit";
      this.showParentForm = !this.showParentForm;
    },
    async addParentToStudent(params) {
      // check if parent ID already exists in student's parent table
      const parentId = params.item.id;
      const parents = this.studentParents;
      if (parents.filter((parent) => parent.id === parentId)) {
        console.log("it already exists!");

        this.scrollTo("student-parents-alert");
        this.flashError();
        return;
      }
      const payload = await {
        parent_uuid: parentId,
        student_uuid: this.$route.params.id,
      };
      await ParentService.addParentToStudent(payload);
      await this.scrollTo("student-parents-alert");
      await this.flashSuccess();
      await this.GET_STUDENT_PARENTS();
    },
    async deleteStudentParent(params) {
      const confirmDelete = confirm(
        "Are you sure you want to remove this parent from this student?"
      );
      if (confirmDelete) {
        await ParentService.deleteStudentParentLink(params);
      }
      await this.GET_STUDENT_PARENTS();
      await this.GET_SCHOOL_PARENTS();
    },
    async onCreateParent(val) {
      setTimeout(() => {
        this.showParentForm = !this.showParentForm;
      }, 1000);
      await this.GET_STUDENT_PARENTS();
      await this.GET_SCHOOL_PARENTS();
      this.clearForm();
    },
    stopClick(row) {},
  },
  computed: {
    ...mapGetters({
      studentParents: "parents/getStudentParents",
      schoolParents: "parents/getSchoolParents",
      isAdmin: "auth/isAdmin",
    }),
    sortOptions() {
      // Create an options list from our fields
      return this.studentParentsFields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  mounted() {
    this.GET_STUDENT_PARENTS();
    this.GET_SCHOOL_PARENTS();
  },
};
</script>

<style scoped>
.add {
  color: green;
  font-weight: bold;
}

.small-date {
  font-style: italic;
  font-size: 10px;
  color: #5a6269;
}
</style>
